import {formatarValorComCasas, nomeMeses} from "../../../../../helpers";
import formatter from "./Formatter";

const options = {
  chart: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    toolbar: {
      show: false
    },
    animations: {
      enabled: false
    }
  },
  plotOptions: {
    bar: {
      endingShape: "flat",
      borderRadius: 1,
      dataLabels: {
        position: "top",
        orientation: "vertical"
      }
    }
  },
  grid: {
    show: true,
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  noData: {
    text: "Carregando... aguarde",
    align: "center",
    verticalAlign: "middle",
    style: {
      fontSize: "14px"
    }
  },
  labels: [],
  legend: {
    show: true,
    position: "top",
    offsetY: 20,
    horizontalAlign: "center",
    markers: {
      width: 13,
      height: 13,
      radius: 0
    }
  },
  dataLabels: {
    enabled: true,
    offsetY: 5,
    enabledOnSeries: [0, 1],
    style: {
      fontSize: "11px",
      fontWeight: undefined,
      colors: ["#000"]
    },
    background: {
      enabled: false
    },
    formatter: function (val) {
      return formatter(val) || "";
    }
  },
  markers: {
    size: [0, 0, 0],
    colors: "#888",
    strokeColors: "#888"
  },
  stroke: {
    show: true,
    curve: "smooth",
    colors: ["", "", "#999"],
    width: 1
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    x: {
      show: true,
      formatter: valor => {
        if (typeof valor != "string") {
          return valor;
        }

        const [mes, ano] = valor.split("/");

        return `${nomeMeses[mes - 1] || mes} de ${ano}`;
      }
    },
    y: {
      show: true,
      format: "dd MMM",
      formatter: valor => formatarValorComCasas(valor, 4)
    }
  },
  fill: {
    opacity: [1, 1, 0.2]
  },
  xaxis: {
    tickPlacement: "between",
    labels: {
      show: true,
      formatter: label => {
        if (typeof label != "string") {
          return "mes/ano";
        }

        const [mes, ano] = label.split('/')
        const anoTxt = `${ano}_`

        return `${mes.substring(0, 3)}/${anoTxt.substring(2, 4)}`
      }
    }
  }
};

export { options };
